import React, { useState, useRef } from "react";
import AvatarEditor from "react-avatar-editor";
import PropTypes from "prop-types";
import { Modal, Slider } from "@mui/material";

import Button from "components/common/Button";
import ImageCropperErrorModal from "components/common/ImageCropperModal/ImageCropperErrorModal";

import "./imageCropperModal.scss";

const modalStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

function ImageCropperModal({ open, onClose, imageSrc, onSave, isFileUploadError, errorMessage }) {
  const focusPoint = useRef(null);
  const [zoom, setZoom] = useState(1.2);

  const handleSave = () => {
    const canvas = focusPoint.current.getImage();

    const optimizedCanvas = document.createElement("canvas");
    const ctx = optimizedCanvas.getContext("2d");
    optimizedCanvas.width = canvas.width;
    optimizedCanvas.height = canvas.height;
    ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height);

    optimizedCanvas.toBlob(
      (blob) => {
        if (blob) {
          const file = new File([blob], "my_image.jpg", {
            type: "image/jpeg",
            lastModified: new Date().getTime(),
          });

          onSave(file);
        }
      },
      "image/jpeg",
      0.7
    );
  };

  return (
    <Modal open={open} onClose={onClose} style={modalStyle}>
      <div
        className="image-cropper-modal"
        style={{
          height: isFileUploadError ? "244px" : "",
          width: isFileUploadError ? "444px" : "600px",
          padding: !isFileUploadError && "16px 0",
        }}
      >
        <p className="heading-h2-semibold image-cropper-horizontal-padding">
          {!isFileUploadError && "Crop and Preview Your Company Logo"}
        </p>
        {!isFileUploadError ? (
          <>
            <p className="para-body-m-regular color-text-body-primary mb-1 image-cropper-horizontal-padding">
              Please upload a high-quality company logo. Ensure it’s centered, clearly visible, and professionally
              appropriate.
            </p>

            <div style={{ position: "relative", background: "black" }}>
              <AvatarEditor
                ref={focusPoint}
                image={imageSrc}
                width={300}
                height={300}
                border={50}
                color={[0, 0, 0, 0.6]}
                scale={zoom}
                rotate={0}
              />
            </div>
            <Slider
              value={zoom}
              min={1}
              max={3}
              step={0.1}
              onChange={(e, value) => setZoom(value)}
              style={{ width: "80%", marginTop: "15px" }}
            />
          </>
        ) : (
          <div>
            <ImageCropperErrorModal errorMessage={errorMessage} closeModal={onClose} />
          </div>
        )}

        {!isFileUploadError && (
          <div className="image-cropper-button-wrapper">
            <Button variant="text" onClick={onClose} label={isFileUploadError ? "Close" : "Cancel"} size="large" />
            {!isFileUploadError && <Button onClick={handleSave} label="Save" size="large" />}
          </div>
        )}
      </div>
    </Modal>
  );
}

ImageCropperModal.propTypes = {
  open: PropTypes.bool,
  isFileUploadError: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  imageSrc: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default ImageCropperModal;
